import { render, staticRenderFns } from "./AppNotificationMenu.vue?vue&type=template&id=368fa842&scoped=true&"
import script from "./AppNotificationMenu.vue?vue&type=script&lang=ts&"
export * from "./AppNotificationMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AppNotificationMenu.vue?vue&type=style&index=0&id=368fa842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368fa842",
  null
  
)

export default component.exports